module.exports = __webpack_public_path__ + "media/images/flags/1x1/ury-d155858f5c92856a3f4cda0c51f636ed.svg";